import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BootstrapSelectDirective } from './bootstrap-select.directive';
import { SingleselectObjectReferenciaComponent } from './singleselect-object-referencia/singleselect-object-referencia.component';
import { MultiselectObjectReferenciaComponent } from '../shared-controls/multiselect-object-referencia/multiselect-object-referencia.component';
import { PaginatorCzComponent } from './paginator-cz/paginator-cz.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [
        BootstrapSelectDirective,
        MultiselectObjectReferenciaComponent,
        SingleselectObjectReferenciaComponent,
        PaginatorCzComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule
    ],
    exports: [
        BootstrapSelectDirective,
        MultiselectObjectReferenciaComponent,
        SingleselectObjectReferenciaComponent,
        PaginatorCzComponent
    ]
  })
  export class SharedControlsModule { }